__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "appdx-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cu/dex-store", "1.0.7", () => (Promise.all([__webpack_require__.e(1148), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(51148))))));
			register("@cu/navigation", "1.1.6", () => (__webpack_require__.e(2641).then(() => (() => (__webpack_require__(32641))))));
			register("connected-react-router", "6.9.3", () => (Promise.all([__webpack_require__.e(9315), __webpack_require__.e(1527), __webpack_require__.e(275), __webpack_require__.e(6653), __webpack_require__.e(5556)]).then(() => (() => (__webpack_require__(19315))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(9733), __webpack_require__.e(1527), __webpack_require__.e(5929)]).then(() => (() => (__webpack_require__(69733))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(1527), __webpack_require__.e(275), __webpack_require__.e(4625)]).then(() => (() => (__webpack_require__(54625))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(6347), __webpack_require__.e(1527)]).then(() => (() => (__webpack_require__(56347))))));
			register("react", "18.2.0", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};